(function () {
  var swiper = new Swiper('.testimonials__slider', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    centeredSlides: true,
    loop: true,
    grabCursor: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      1000: {
        spaceBetween: 32,
      },
    },
  });
})();
